import api from "./api";

const transferService = {
    transfer: (jwttoken, token, qtd, toUserId, password) =>
        api.post(`/transfer`, {
            token, 
            qtd, 
            toUserId,
            password
        }, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
};

export default transferService;